"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ensureLength(args, message, minLength = 1) {
    if (args.length < minLength) {
        throw new Error(message);
    }
}
exports.ensureLength = ensureLength;
